import React, { useEffect } from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import AddNewCourtForm1 from "../../components/auth/AddNewCourtForm1";
import { useParams } from "react-router-dom";
import { useGetCourtByIdQuery } from "../../lib/redux/services/sections/Courts";
import Loader from "../../components/skeletons/Loader";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const AddNewCourt1 = () => {
  const { Auth }: DictionaryType = useGetDictionary();
  const { club_id, court_id } = useParams();
  
  const { data, isLoading, isFetching } = useGetCourtByIdQuery(court_id);
  let CourtData;

  // useEffect(() => {
  //   refetch();
  // }, [data, refetch]);

  if (!isLoading && data) {
    CourtData = {
      court_type: data.data.court_type,
      name: data.data.name,
      privacy_options: data.data.privacy_options,
      images: data.data.photos,
    };
  }

  return (
    <AuthLayout>
      <div className="  flex flex-col gap-8 px-12 ">
        <div className="flex flex-col gap-5 text-center mb-10">
          <PageTitle title={Auth?.add_new_court.add_new_court_title} />
        </div>

        {court_id ? (
          isFetching ? (
            <div className="h-[300px]">
              <Loader />
            </div>
          ) : (
            <AddNewCourtForm1 data={CourtData} />
          )
        ) : (
          <AddNewCourtForm1 />
        )}
      </div>
    </AuthLayout>
  );
};

export default AddNewCourt1;
